export const categories = [
  {
    name: "Shoes",
    label: "Buty",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
  },
  {
    name: "Hoodies/Sweaters",
    label: "Bluzy / Swetry",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
  },
  {
    name: "T-Shirts",
    label: "Koszulki",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-t-shirt-air-line",
  },
  {
    name: "Jackets",
    label: "Kurtki",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-windy-line",
  },
  {
    name: "Pants/Shorts",
    label: "Spodnie / Szorty",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-scissors-line",
  },
  {
    name: "Headwear",
    label: "Nakrycia Głowy",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-customer-service-2-line",
  },
  {
    name: "Sets",
    label: "Zestawy",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
  },
  {
    name: "Underwear/Underpants",
    label: "Bielizna",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-shirt-line",
  },
  {
    name: "Jersey",
    label: "Koszulki Sportowe",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-basketball-line",
  },
  {
    name: "Accessories",
    label: "Akcesoria",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-glasses-line",
  },
  {
    name: "Bags",
    label: "Torby",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
  },
  {
    name: "Belts",
    label: "Paski",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-link",
  },
  {
    name: "Perfumes",
    label: "Perfumy",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
  },
  {
    name: "Other Stuff",
    label: "Inne Produkty",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-line",
  },
];